import { apiRequest } from './apiClient';

export const getExpenses = async () => {
  return apiRequest('/expenses');
};

export const createExpense = async (expenseData) => {
  return apiRequest('/expenses', { method: 'POST', body: expenseData, modelLabel: 'gasto' });
};

export const updateExpense = async (id, expenseData) => {
  return apiRequest(`/expenses/${id}`, { method: 'PUT', body: expenseData, modelLabel: 'gasto' });
};

export const deleteExpense = async (id) => {
  return apiRequest(`/expenses/${id}`, { method: 'DELETE', modelLabel: 'gasto' });
};

